import React, { useEffect } from 'react'
import { useHistory } from "react-router-dom"
import {
  Row,
  Col,
  Button,
  message,
  // Checkbox
} from 'antd'
import { UserSwitchOutlined, StopOutlined } from '@ant-design/icons'
import logo from "../assets/images/logo.png"
import { useAuth } from "../contexts/AuthContext"

const UserStatus = () => {
  const history = useHistory()
  const { logout, user } = useAuth()

  useEffect(() => {
    if (user.status === 'a') {
      message.info("Your account is approved!")
      history.push("/")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  return (
    <Row justify="center" align="middle" className="auth-container">
      <Col span={24}>
        <Row justify="center">
          <Col span={24} className="logo-container">
            <img src={logo} alt="" className="auth-logo" />
          </Col>
          <Col span={24}>
            <Row justify="center">
              <Col span={24} lg={{ span: 7 }}>
                <div className="form-container">
                  <div className="form-header">
                    {user.status === 'p' && (
                      <>
                      <UserSwitchOutlined style={{ fontSize: "10em" }} />
                        <h1>Your Account is Pending</h1>
                        <p>After approval, You will get access of this portal.</p>
                      </>
                    )}
                    {user.status === 'b' && (
                      <>
                      <StopOutlined style={{ fontSize: "10em" }} />
                        <h1>Your Account is Blocked</h1>
                        <p>You can't get access of this portal.</p>
                      </>
                    )}
                    <span className=" ant-btn-lg">
                      <Button type="primary" onClick={() => logout("/auth/login")} size="large">Log Out</Button>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default UserStatus
